import { useExportFileDownload } from '@aibees/elephant/feature/exports-management-table/actions/export-file-action';
import { Label } from '@aibees/shared/components';
import { ExportStatus } from '@aibees/shared/components/status-tag';
import { LoadingButton } from '@mui/lab';
import { memo } from 'react';
import type { DownloadEnrichRecordProps as Props } from './types';

export const DownloadEnrichRecord = memo(
  ({ className: _className, item }: Props) => {
    const { downloadFile, isDownloading } = useExportFileDownload(item);

    if (item.status === ExportStatus.SUCCESS)
      return (
        <LoadingButton
          onClick={downloadFile}
          variant="contained"
          color="primary"
          size="xsmall"
          fullWidth
          disabled={isDownloading}
          loading={isDownloading}
        >
          Download
        </LoadingButton>
      );

    if (
      item.status === ExportStatus.PENDING ||
      item.status === ExportStatus.EXPORTING
    )
      return (
        <Label size="xsmall" color="warning" variant="soft" fullWidth>
          Processing
        </Label>
      );

    return (
      <Label size="xsmall" color="error" variant="soft" fullWidth>
        Failed
      </Label>
    );
  }
);

DownloadEnrichRecord.displayName = 'DownloadEnrichRecord';
